import React from "react"

class ManageYearFormComponent extends React.Component {

	render() {
		const descs = this._buildDescs()
		return (
			<form onSubmit={this.props.onSubmit}>
				<div>{descs.desc}</div>
				{ descs.subdesc
					? <span className="subdesc">{descs.subdesc}</span>
					: null
				}
				<div className="columns">
					<div className="column">
						<button className={`button is-primary ${this.props.submitting ? "is-loading" : ""}`}>
							Oui
						</button>
					</div>
				</div>
			</form>
		)
	}

	_buildDescs() {
		var descs = {
			desc: null,
			subdesc: null
		}
		switch(this.props.action) {
			case "add":
				descs.desc = "Êtes-vous sûr de vouloir ajouter une année au PPI en cours ?"
				break
			case "delete":
				descs.desc = "Êtes-vous sûr de vouloir supprimer la dernière colonne du PPI ?"
				descs.subdesc = "Cette action est irreversible, les données saisies dans cette colonne seront supprimées définitivement"
				break
		}
		return descs
	}

	_handleSubmit = (/** @type {React.SyntheticEvent<Element>} */ event) => {
		event.preventDefault();
		event.persist()
		this.setState({ submitting: true })
	}

}

export default ManageYearFormComponent



// WEBPACK FOOTER //
// ./src/component/ppi/ppi-detail/manage-year-form-component.js